import { DomainError } from 'domain-errors';

import { ErrorCode } from './espb/error_codes_pb';

/* This class is used by client-node-bridge, handle with care!
 * Contract (in addition to type adherence):
 *   - name field must be 'DomainError'
 *   - JSON.stringify-friendly
 */

export const BackendErrorCode = ErrorCode;

export class BackendDomainError extends DomainError {
  constructor(
    readonly grpcStatus: number,
    code: number,
    short: string,
    userTitle: string,
    userDetail: string,
    readonly requestId: string,
  ) {
    super(code, short, userTitle, userDetail);
    this.name = 'BackendDomainError';
  }
}
